import { Input } from "reactstrap";
import { SelectInputProps } from "../../../../../types/Ecommerce";

// This component is used to create a select input field with custom styles.
const SelectInput: React.FC<SelectInputProps> = ({ data, size, selectClass }) => {

  return (
    <div className={`mb-3 ${selectClass}`}>
      <Input type="select" size={size}>
        {data.map((item, index) => (
          <option key={index}>{item}</option>
        ))}
      </Input>
    </div>
  );
};

export default SelectInput;
